import React from "react";
import { Link as MuiLink, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import palette from "src/theme/palette";
import EmptyBox from "src/static/images/empty_box.svg";
import { TABS } from "../AccountSettings.consts";

const Container = styled(Stack)({
  backgroundColor: palette.system[0],
  border: "1px solid",
  borderColor: palette.grey[200],
  borderRadius: 8,
  justifyContent: "center",
  alignItems: "center",
  minHeight: 400
});

const SubscriptionEmptyState = () => (
  <Container data-testid="subscription-empty-state">
    <Stack alignItems="center" gap={1}>
      <img src={EmptyBox} alt="" />
      <Typography variant="body1" color="text.700" sx={{ mt: 2 }}>
        Nothing here yet.
      </Typography>
      <Typography variant="body2" color="text.600" textAlign="center" maxWidth={240}>
        Connect your{" "}
        <MuiLink component={Link} to={`?tab=${TABS.GENERAL}`} underline="hover" color="primary.500">
          Salesforce account
        </MuiLink>{" "}
        to track subscription activity here.
      </Typography>
    </Stack>
  </Container>
);

export default SubscriptionEmptyState;
